import { render } from "./page6.vue?vue&type=template&id=2e4af22c"
import script from "./page6.vue?vue&type=script&lang=js"
export * from "./page6.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__